import React from "react";
import { Helmet } from "react-helmet";
import { DEFAULT_OG_IMAGE } from "./seoConfig";
import { buildJsonLd, buildPageUrl } from "./schemaBuilders";

function SeoMeta({ page, includeCanonical = true }) {
  if (!page) {
    return null;
  }

  const url = buildPageUrl(page.path);
  const image = page.image || DEFAULT_OG_IMAGE;
  const jsonLd = buildJsonLd(page);

  return (
    <Helmet>
      <title>{page.title}</title>
      <meta name="title" content={page.title} />
      <meta name="description" content={page.description} />
      <meta name="keywords" content={page.keywords} />
      <meta name="robots" content={page.robots || "index, follow"} />
      <meta name="author" content={page.author || "SeoBix Team"} />
      {includeCanonical && <link rel="canonical" href={url} />}

      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={page.ogTitle || page.title} />
      <meta
        property="og:description"
        content={page.ogDescription || page.description}
      />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={page.imageAlt || page.title} />
      <meta property="og:site_name" content="SeoBix" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={page.twitterTitle || page.title} />
      <meta
        name="twitter:description"
        content={page.twitterDescription || page.description}
      />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={page.imageAlt || page.title} />
      <meta name="twitter:site" content="@seobix" />
      <meta name="twitter:creator" content="@seobix" />

      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}

export default SeoMeta;
